import BaseListSlick, {
  styles as baseStyles,
} from '../../core/Shared/ListSlick';
import { HOME_LIST_SLICK_AUTOPLAY_MS } from '../constants/homeListSlick';

export const styles = (theme) => ({
  ...baseStyles(theme),
  root: {
    marginLeft: 0,
    marginRight: 0,
  },
});

class ListSlick extends BaseListSlick {
  settings = (theme) => ({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: HOME_LIST_SLICK_AUTOPLAY_MS,
    responsive: [
      {
        breakpoint: theme.breakpoints.values.lg,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          infinite: false,
          slidesToShow: 2.25,
          arrows: false,
        },
      },
    ],
  });
}

export default ListSlick;
